import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out
  const [token, setToken] = useState(localStorage.getItem("cp_token"));

  useEffect(() => {
    let active = true;
    async function check() {
      const t = localStorage.getItem("cp_token");
      if (!t) { if (active) setUser(false); return; }
      try {
        const { data } = await api.get("/auth/me");
        if (active) setUser(data);
      } catch {
        localStorage.removeItem("cp_token");
        if (active) { setUser(false); setToken(null); }
      }
    }
    check();
    return () => { active = false; };
  }, []);

  async function login(email, password) {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("cp_token", data.token);
      setToken(data.token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  }

  async function register(payload) {
    try {
      const { data } = await api.post("/auth/register", payload);
      localStorage.setItem("cp_token", data.token);
      setToken(data.token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  }

  function setSession(data) {
    localStorage.setItem("cp_token", data.token);
    setToken(data.token);
    setUser(data.user);
  }

  function logout() {
    localStorage.removeItem("cp_token");
    setToken(null);
    setUser(false);
  }

  return (
    <AuthContext.Provider value={{ user, token, login, register, logout, setSession }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
